import ReactGA from "react-ga4";

ReactGA.initialize("G-B8Y3YHYHB1");

export function trackEvent(action, label) {
  ReactGA.event(action, { event_category: "News journey", ...(label ? { event_label: label } : {}) });
}

export function trackVisit() {
  try {
    const previous = localStorage.getItem("pbn-last-visit");
    if (previous) trackEvent("return_visit");
    localStorage.setItem("pbn-last-visit", new Date().toISOString());
  } catch (_) {
    // The site remains usable when storage is disabled.
  }
}
